import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Skeleton, Stack, SwipeableDrawer } from "@mui/material";
import React from "react";
import { Button } from "reactstrap";
import "./common.css";
import { Icon } from "@iconify/react/dist/iconify.js";
//Import Breadcrumb

const AppDialog = ({
    open, width, title, close, children, fullWidth = false,
    closable, disabled, negativePress, negativeTitle, positivePress,
    positiveTitle, positiveButtonStyle, negativeButtonStyle, actionButtonStyle,
    titleIcon, cancelButton = false, contentSx, buttonSpaceBetween, textOnButtonBar, isMobile = false, customTitle, dialogActionStyle, mobileSizeModalMaxHeight
}) => {
    return (
        <React.Fragment>
            {
                isMobile ?
                    <SwipeableDrawer
                        anchor="bottom"
                        open={open}
                        onOpen={() => ''}
                        onClose={(e) => close()}
                        disableSwipeToOpen={true}
                        sx={{
                            "& .MuiPaper-root": {
                                borderTopLeftRadius: "30px",
                                borderTopRightRadius: "30px",
                                maxHeight: mobileSizeModalMaxHeight,
                            },
                        }}
                    >
                        <div className="p-4" style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }}>
                            <div style={{ width: 60, justifySelf: 'center', height: 5, backgroundColor: '#DEDEDE', borderRadius: 50, marginBottom: 20 }}></div>
                            {
                                title &&
                                <div className="my-3 justify-self-center text-semibold font-size-16 text-center">
                                    {title}
                                    <Divider className="mt-3" />
                                </div>
                            }
                            <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', paddingBottom: 150 }}>{children}</div>
                            <div className="position-absolute bottom-0 left-0 p-3" style={{ borderTop: '1px solid #DFDFDF', backgroundColor: 'white', width: '93vw' }}>
                                {textOnButtonBar && <div className="mt-2 text-center">{textOnButtonBar}</div>}
                                {customTitle ?
                                    customTitle
                                    : <Stack
                                        justifyContent={'center'}
                                        direction={"row"}
                                        sx={{ width: "100%", mt: 1, mb: 1 }} // Ensure the Stack takes full width
                                    >
                                        {
                                            cancelButton &&
                                            <Button
                                                onClick={(e) => close()}
                                                style={{
                                                    color: '#808588',
                                                    borderRadius: "20px",
                                                    backgroundColor: '#F9F9F9',
                                                    border: '1px solid #F9F9F9',
                                                    width: "100%", // Ensure button width is determined by content
                                                    padding: 20,
                                                    height: 42
                                                }}
                                                className="me-1 modal-negative-button"
                                                type="submit"
                                            >
                                                {'Cancel'}
                                            </Button>
                                        }
                                        {
                                            negativeTitle &&
                                            <Button
                                                onClick={(e) => negativePress()}
                                                style={negativeButtonStyle || {
                                                    color: "black",
                                                    borderRadius: "20px",
                                                    backgroundColor: "white",
                                                    border: "1px solid black",
                                                    width: "100%", // Ensure button width is determined by content
                                                    padding: 20,
                                                    height: 42
                                                }}
                                                className="me-1 modal-negative-button"
                                                type="submit"
                                            >
                                                {negativeTitle}
                                            </Button>
                                        }
                                        {positiveTitle &&
                                            <Button
                                                color="primary"
                                                className="modal-positive-button"
                                                style={positiveButtonStyle || {
                                                    color: "white",
                                                    borderRadius: "20px",
                                                    backgroundColor: "black",
                                                    border: "1px solid black",
                                                    width: "100%", // Ensure button width is determined by content
                                                    padding: 20,
                                                    height: 42
                                                }}
                                                type="submit"
                                                disabled={disabled || false}
                                                onClick={(e) => positivePress()}
                                            >
                                                <span style={{ whiteSpace: "nowrap" }}>{positiveTitle}</span>
                                            </Button>
                                        }
                                    </Stack>
                                }
                            </div>
                        </div>
                    </SwipeableDrawer>
                    :
                    <Dialog
                        open={open}
                        fullWidth={fullWidth}
                        PaperProps={{
                            sx: {
                                // height: height || '700px',
                                width: { xs: "100%", sm: width || '70%' },
                                borderRadius: "10px",
                                maxWidth: { xs: "100%", sm: width || '70%' },
                                overflow: 'hidden',
                            }
                        }}
                        onClose={(e) => close()}
                    >
                        <DialogTitle style={{ paddingInline: '35px', paddingBlock: '20px' }}>
                            {/* <span style={{ fontSize: "16px", fontWeight: 500 }}>{title}</span> */}
                            <IconButton
                                aria-label="close"
                                onClick={(e) => close()}
                                sx={(theme) => ({
                                    position: 'absolute',
                                    right: 20,
                                    top: 15,
                                    color: '#1D1B1B',
                                    backgroundColor: '#F4F4F4',
                                    borderRadius: '5px',
                                    padding: '7px'
                                })}
                            >
                                <Icon icon="mdi:window-close" style={{ height: 18, width: 18 }} />
                            </IconButton>
                        </DialogTitle>

                        {/* {title && <Divider className="mb-2" />} */}
                        <DialogContent className="" style={{ paddingInline: '35px', borderRadius: '0 0 15px 15px' }} sx={{ overflowY: 'auto', ...(contentSx || {}) }}>
                            <div className="mt-2 mb-4" style={{ fontSize: "18px", fontWeight: 500, color: '#0E172C', fontFamily: 'SophiaPro-Medium'}}>{title}</div>
                            {children}
                        </DialogContent>
                        <DialogActions className={actionButtonStyle || ''} style={{ padding: '15px', paddingInline: '30px', ...dialogActionStyle }}>
                            {textOnButtonBar && textOnButtonBar}

                            {customTitle ?
                                customTitle
                                : <Stack
                                    justifyContent={buttonSpaceBetween ? "space-between" : "flex-end"}
                                    direction={"row"}
                                    gap={1}
                                    sx={{ width: "100%" }} // Ensure the Stack takes full width
                                >
                                    {
                                        cancelButton &&
                                        <Button
                                            onClick={(e) => close()}
                                            style={{
                                                color: '#594A4E',
                                                borderRadius: "12px",
                                                backgroundColor: '#F9F9F9',
                                                border: '1px solid #F9F9F9',
                                                width: "auto", // Ensure button width is determined by content
                                            }}
                                            className="me-1 modal-negative-button"
                                            type="submit"
                                        >
                                            {'Cancel'}
                                        </Button>
                                    }
                                    {
                                        negativeTitle &&
                                        <Button
                                            onClick={(e) => negativePress()}
                                            style={negativeButtonStyle || {
                                                color: "#594A4E",
                                                borderRadius: "12px",
                                                backgroundColor: "white",
                                                border: "1px solid #F9F9F9",
                                                width: "auto", // Ensure button width is determined by content
                                            }}
                                            className="me-1 modal-negative-button"
                                            type="submit"
                                        >
                                            {negativeTitle}
                                        </Button>
                                    }
                                    {positiveTitle &&
                                        <Button
                                            color="primary"
                                            className="modal-positive-button"
                                            style={positiveButtonStyle || {
                                                color: "white",
                                                borderRadius: "12px",
                                                backgroundColor: "var(--bs-theme-color)",
                                                border: "1px solid var(--bs-theme-color)",
                                                width: "auto", // Ensure button width is determined by content
                                            }}
                                            type="submit"
                                            disabled={disabled || false}
                                            onClick={(e) => positivePress()}
                                        >
                                            <span style={{ whiteSpace: "nowrap" }}>{positiveTitle}</span>
                                        </Button>
                                    }
                                </Stack>}
                        </DialogActions>
                    </Dialog>
            }
        </React.Fragment>
    );
};

export default AppDialog;
